import React from 'react';

// Components
import Icon from '../shared/Icon';
import { Modal as AntModal } from 'antd';
import { bodyScrollFix } from '../utils';

const ModalWrapper = ({
  _state,
  wrapClassName,
  id,
  children,
  onClose = () => null,
}) => {
  const [state, setState] = _state;
  const elId = id !== undefined ? `id-${id}` : '';
  return (
    <AntModal
      centered
      visible={state}
      onOk={() => {
        setState(false);
        bodyScrollFix();
      }}
      onCancel={() => {
        setState(false);
        onClose();
        bodyScrollFix();
      }}
      footer={null}
      width="100%"
      wrapClassName={`${wrapClassName} ${elId}`}
      closeIcon={<Icon name="close" />}
      afterClose={bodyScrollFix}
    >
      {children}
    </AntModal>
  );
};

export default ModalWrapper;
